import moment from 'moment';

export function isDeliveryAlreadyBooked(deliveryBookedAt) {
    if (!deliveryBookedAt) {
        return false;
    }

    const bookedDate = moment.utc(deliveryBookedAt);
    const currentDate = moment.utc();

    const differenceInMinutes = currentDate.diff(bookedDate, 'minutes');

    if (differenceInMinutes < 5) {
        return true;
    }

    return false;
}


// WEBPACK FOOTER //
// ./src/helpers/deliveryBookedDateHelper.js